import React, { useState, MouseEvent } from "react";
import { getMenu } from "../../Components/Dashboard/menu";
import { WSIcons } from "../../commonFunctions/iIcons";
import { Email, Storefront, Settings, Notifications, Person, Logout } from "@mui/icons-material";
import { BottomNavigation, BottomNavigationAction, Paper, Badge, Avatar, Popover, List, ListItem, ListItemText, Divider } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

interface NavigationItem {
  path?: string;
  icon: React.ReactNode;
  label: string;
  children?: NavigationItem[];
}

interface WSBottomNavProps {
  navigationItems: NavigationItem[];
}

const WSBottomNav: React.FC<WSBottomNavProps> = ({ navigationItems }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = useState(location.pathname);
  const [popoverAnchor, setPopoverAnchor] = useState<null | HTMLElement>(null);
  const [currentChildren, setCurrentChildren] = useState<NavigationItem[]>([]);

  const handleOpenPopover = (event: MouseEvent<HTMLElement>, children: NavigationItem[]) => {
    setPopoverAnchor(event.currentTarget);
    setCurrentChildren(children);
  };

  const handleClosePopover = () => {
    setPopoverAnchor(null);
  };

  return (
    <Paper sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1400 }} elevation={3}>
      <BottomNavigation
        value={value}
        onChange={(event, newValue) => {
          if (typeof newValue === "string") {
            navigate(newValue);
            setValue(newValue);
          }
        }}
        showLabels
      >
        {navigationItems.map(({ path, icon, label, children }) => (
          children?.length ? (
            <BottomNavigationAction
              key={label}
              label={label}
              icon={icon}
              onClick={(e) => handleOpenPopover(e, children)}
            />
          ) : (
            <BottomNavigationAction
              key={path}
              label={label}
              icon={icon}
              value={path}
            />
          )
        ))}
      </BottomNavigation>

      {/* Popover for Children */}
      <Popover
        open={Boolean(popoverAnchor)}
        anchorEl={popoverAnchor}
        onClose={handleClosePopover}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        transformOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <List sx={{ width: 200 }}>
          {currentChildren.map((child) => (
            <ListItem button key={child.path} onClick={() => navigate(child.path!)}>
              {child.icon}
              <ListItemText primary={child.label} sx={{ marginLeft: 1 }} />
            </ListItem>
          ))}
        </List>
      </Popover>
    </Paper>
  );
};

const BottomNavContainer: React.FC<{ userType: string }> = ({ userType }) => {
  const menuData = getMenu(userType).staticMenu;

  const navigationItems = menuData.map((item: any) => ({
    path: item.path,
    icon: typeof item.icon === 'function' ? <item.icon /> : <WSIcons.DealIcon />,
    label: item.label,
    children: item.children?.map((child: any) => ({
      path: child.path,
      icon: typeof child.icon === 'function' ? <child.icon /> : <WSIcons.AddIcon />,
      label: child.label
    })) || []
  }));

  return <WSBottomNav navigationItems={navigationItems} />;
};

export default BottomNavContainer;
